// extracted by mini-css-extract-plugin
export default {"description-container":"description-container--mp-F9iko","descriptionContainer":"description-container--mp-F9iko","wrapper":"wrapper--mp-KjGWK","short":"short--mp-kAQx0"};